<template>
  <div class="store_link_list baby_manage_tabs" :style="{'overflow-y' : overflowY}">
    <!--tabs切换-->
    <div class="baby_manage_tabs_box">
      <ul>
        <li @click="tabsChange('storeGoodList')">店铺货品列表</li>
        <li class="active">店铺链接列表</li>
        <li @click="tabsChange('cannotLinkList')">无法识别链接列表</li>
      </ul>
    </div>
    <!--店铺链接列表模糊查询-->
    <div class="store_link_list_top">
      <div class="first_line">
        <div>
          <el-select v-model="selectStore" placeholder="请选择">
            <el-option
              v-for="item in storeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectBrand" placeholder="请选择">
            <el-option
              v-for="item in brandsList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectCodeSegment" placeholder="请选择">
            <el-option
              v-for="item in codeSegmentList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectGoodsType" placeholder="请选择">
            <el-option
              v-for="item in goodsTypeList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectOnState" placeholder="请选择">
            <el-option
              v-for="item in onStateList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-select v-model="selectInventoryDocking" placeholder="请选择">
            <el-option
              v-for="item in inventoryDockingList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        库存
        <div class="inventory_list">
          <el-select v-model="selectInventorySymbol" placeholder="请选择">
            <el-option
              v-for="item in inventorySymbolList"
              :key="item.id"
              :label="item.text"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="inventory_msg">
          <input type="text" v-model.trim="inventory" placeholder="库存">
        </div>
      </div>
      <div class="second_line">
        <div><input type="text" v-model.trim="merchantNum" title="商家编码" placeholder="商家编码"></div>
        <div><input type="text" v-model.trim="linkId" title="链接ID" placeholder="链接ID"></div>
        <div><input type="text" v-model.trim="linkName" title="链接名称" placeholder="链接名称"></div>
        <div><input type="text" v-model.trim="goodsNum" title="货号/品名" placeholder="货号/品名"></div>
        <button class="btn_normal w116" @click="queryData()">查询</button>
      </div>
      <div class="third_line mb5">
        <button class="btn_normal" @click="ctrlBtn('batchSllSetInventoryObject')">批量设置链接库存对接</button>
        <button class="btn_normal" @click="ctrlBtn('batchCloseInventoryObject')">批量关闭链接库存对接</button>
        <button class="btn_normal" @click="exportShopLinkExcel()">店铺链接导出</button>
        <button class="btn_normal" @click="ctrlBtn('batchSynchronousInventory')">批量同步库存</button>
        <button class="btn_normal" @click="ctrlBtn('import')">导入猫超商品资料</button>
      </div>
    </div>

    <!--店铺链接列表信息-->
    <div class="store_link_list_msg">
      <!--表格-->
      <table class="table tb_border">
        <thead>
        <tr>
          <th><input type="checkbox" title="全选" v-model="checkAll" @click="checkOneOrAll()"/></th>
          <th>图片</th>
          <th>ID</th>
          <th>链接名称</th>
          <th>上架状态</th>
          <th>对接状态</th>
          <th>库存</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody v-if="list.length">
        <tr v-for="(item, index) in list" :key="index">
          <td><input type="checkbox" title="选择" v-model="checkboxModel[index]"></td>
          <td><img :src="item.LinkImgUrl" height="50" width="50"/></td>
          <td>{{item.NumId}}</td>
          <td>{{item.Title}}</td>
          <td>{{item.Status | onstatelink}}</td>
          <td>{{item.StockStatus | inventorydockinglink}}</td>
          <td>{{item.LinkStock}}</td>
          <td>
            <a title="连接详情" @click="ctrlBtn('sllLinkDetail', item)">链接详情</a>
            <a title="设置库存对接" @click="ctrlBtn('sllSetInventoryObject', item)">设置库存对接</a>
            <a title="同步库存" @click="ctrlBtn('sllSynchronizationOfInventory', item)">同步库存</a>
            <a title="上下架" @click="ctrlBtn('sllNumUpDown', item)">上下架</a>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!list.length">
        <tr>
          <td colspan="8">暂时没有相关信息</td>
        </tr>
        </tbody>
      </table>

      <!--分页-->
      <div class="paging" v-if="list.length">
        <el-pagination
          background
          :prev-text="'上一页'"
          :next-text="'下一页'"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 15, 20, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!--弹出框-->
    <store-link-list-embed-msg v-if="isShow"
                               :title="dialogTitle"
                               :linkMsg="linkMsg"
                               :shopId="selectStore"
                               :showType="dialogShowType" @cancelbtn="getSelectDialogEmbed"></store-link-list-embed-msg>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="'NOP'"></loading-dialog>
  </div>
</template>

<script type="es6">
  import StoreLinkListEmbedMsg from './store-link-list-embed-msg';
  import MsgDialog from '../../../public-component/msg-dialog';
  import LoadingDialog from '../../../public-component/loading-dialog';

  export default {
    name: 'store-link-list',
    components: {StoreLinkListEmbedMsg, MsgDialog, LoadingDialog},
    watch: {
      'isShow': function (val) {
        if (val) {
          this.overflowY = 'hidden';
        } else {
          this.overflowY = 'auto';
        }
      },
      'checkboxModel': function (val) {
        let flag = true;
        val.forEach((value) => {
          if (!value) {
            flag = false;
            return flag;
          }
        });
        this.checkAll = flag;
        if (!this.checkboxModel.length) {
          this.checkAll = false;
        }
      } // 单选
    },
    data() {
      return {
        list: [], // 链接信息列表
        checkAll: false, // 全选
        checkboxModel: [], // checkbox框值
        linkMsg: null, // 链接信息
        storeList: [
          // {id: '尚动天猫', text: '尚动天猫'}
        ], // 店铺下拉
        selectStore: '', // 店铺选择
        brandsList: [
          {id: '', text: '所有品牌'}
        ], // 品牌下拉
        selectBrand: '', // 品牌选择
        codeSegmentList: [
          {id: '', text: '所有码段'}
        ], // 码段下拉
        selectCodeSegment: '', // 码段选择
        goodsTypeList: [
          {id: '', text: '所有分类'}
        ], // 商品分类下拉
        selectGoodsType: '', // 商品分类选择
        onStateList: [
          {id: 0, text: '上架状态'},
          {id: 1, text: '上架'},
          {id: 2, text: '下架'}
        ], // 上架状态下拉
        selectOnState: 0, // 上架状态选择
        inventoryDockingList: [
          {id: 3, text: '库存对接状态'},
          {id: 1, text: '开启'},
          {id: 2, text: '关闭'}
        ], // 库存对接状态下拉
        selectInventoryDocking: 3, // 对接状态选择
        inventorySymbolList: [
          {id: 0, text: '符号'},
          {id: 1, text: '='},
          {id: 2, text: '>'},
          {id: 3, text: '>='},
          {id: 4, text: '<'},
          {id: 5, text: '<='}
        ], // 库存符号下拉
        selectInventorySymbol: 0, // 库存符号选择
        inventory: '', // 库存信息
        merchantNum: '', // 商家编码
        linkId: '', // 链接ID
        linkName: '', // 链接名称
        goodsNum: '', // 货号/品名
        overflowY: 'auto', // 是否出现滚动
        isLoading: false, // 是否显示加载框
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 10 // 总条数
      }
    },
    methods: {
      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              this.selectStore = res.data.resData[0].id;
              // 获取店铺货品列表分页数据
              this.loadAllShopLinkPageData();
            } else {
              this.storeList = res.data.resData;
              this.selectStore = '';
            }
          } else {
            this.storeList = [];
            this.selectStore = res.data.errorMsg;
          }
        });
      },

      // 加载品牌下拉数据
      getAllBrandsList() {
        this.$axios.get(this.Global.getAllBrandsList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.brandsList = res.data.resData;
            this.brandsList.splice(0, 0, {id: '', text: '所有品牌'});
            this.selectBrand = '';
          } else {
            this.brandsList = [];
            this.selectBrand = res.data.errorMsg;
          }
        });
      },

      // 加载码段下拉数据
      getAllSizeGroupList() {
        this.$axios.get(this.Global.getAllSizeGroupList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.codeSegmentList = res.data.resData;
            this.codeSegmentList.splice(0, 0, {id: '', text: '所有码段'});
            this.selectCodeSegment = '';
          } else {
            this.codeSegmentList = [];
            this.selectCodeSegment = res.data.errorMsg;
          }
        });
      },

      // 加载分类下拉数据
      getAllClassList() {
        this.$axios.get(this.Global.getAllClassList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.goodsTypeList = res.data.resData;
            this.goodsTypeList.splice(0, 0, {id: '', text: '所有分类'});
            this.selectGoodsType = '';
          } else {
            this.goodsTypeList = [];
            this.selectGoodsType = res.data.errorMsg;
          }
        });
      },

      // 根据查询条件查询
      queryData() {
        this.currentPage = 1;
        this.loadAllShopLinkPageData();
      },

      // 店铺链接分页数据
      loadAllShopLinkPageData() {
        this.isLoading = true;
        const params = {
          ShopId: this.selectStore, // 店铺Id
          BrandId: this.selectBrand, // 品牌Id
          SgId: this.selectCodeSegment, // 码段Id
          ClassId: this.selectGoodsType, // 分类Id
          ShelfStatus: this.selectOnState, // 上架状态 1上架,2.下架
          StockStatus: this.selectInventoryDocking, // 库存对接状态  1=开启 2=关闭
          Symbol: this.selectInventorySymbol, // 符号
          Stocknumber: this.inventory, // 库存
          BusinessCode: this.merchantNum, // 商家编码
          LinkId: this.linkId, // 链接Id
          LinkName: this.linkName, // 链接Name
          GoodsIdOrName: this.goodsNum, // 货号货名
          pageIndex: this.currentPage, // 页码，默认为第1页
          pageSize: this.pageSize // 每页数量，默认为10
        };
        this.$axios.post(this.Global.loadAllShopLinkPageData, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            self.isLoading = false;
            clearTimeout(timer);
            if (res) {
              self.checkAll = false;
              self.checkboxModel = [];
              if (!res.data.errorMsg.length) {
                self.list = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
                for (let i = 0; i < res.data.resData.DataList.length; i++) {
                  self.checkboxModel.push(false);
                }
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.list = [];
                self.total = 0;
              }
            }
          }, 500);
        });
      },

      // 店铺链接列表 导出excel
      exportShopLinkExcel() {
        const params = {
          ShopId: this.selectStore, // 店铺Id
          BrandId: this.selectBrand, // 品牌Id
          SgId: this.selectCodeSegment, // 码段Id
          ClassId: this.selectGoodsType, // 分类Id
          ShelfStatus: this.selectOnState, // 上架状态 1上架,2.下架
          StockStatus: this.selectInventoryDocking, // 库存对接状态  1=开启 2=关闭
          Symbol: this.selectInventorySymbol, // 符号
          Stocknumber: this.inventory, // 库存
          BusinessCode: this.merchantNum, // 商家编码
          LinkId: this.linkId, // 链接Id
          LinkName: this.linkName, // 链接Name
          GoodsIdOrName: this.goodsNum, // 货号货名
          pageIndex: this.currentPage, // 页码，默认为第1页
          pageSize: this.pageSize // 每页数量，默认为10
        };
        this.$axios.post(this.Global.exportShopLinkExcel, params).then((res) => {
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
          } else {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请选择要批量操作的货号';
          }
        });
      },

      // 单选/全选
      checkOneOrAll() {
        for (let i = 0; i < this.checkboxModel.length; i++) {
          this.checkboxModel[i] = !this.checkAll;
        }
      },

      // 操作按钮
      ctrlBtn(type, linkMsg) {
        this.dialogShowType = type;
        this.linkMsg = linkMsg;
        switch (type) {
          case 'sllLinkDetail':
            this.isShow = true;
            this.dialogTitle = '链接详情';
            break;
          case 'import':
            this.isShow = true;
            this.dialogTitle = '导入猫超商品资料';
            break;
          case 'sllSetInventoryObject':
            this.isShow = true;
            this.dialogTitle = '设置库存对接';
            break;
          case 'sllSynchronizationOfInventory':
            this.isShow = true;
            this.dialogTitle = '同步库存';
            break;
          case 'sllNumUpDown':
            this.isShow = true;
            this.dialogTitle = '上下架';
            break;
          case 'batchSllSetInventoryObject': case 'batchCloseInventoryObject': case 'batchSynchronousInventory':
            let checkboxModelLst = []; // 选择的链接
            this.checkboxModel.findIndex((val, i) => {
              if (val === true) {
                checkboxModelLst.push(this.list[i].NumId);
              }
            });
            if (!checkboxModelLst.length) {
              this.isMsg = true;
              this.isSuc = false;
              this.txtMsg = '请选择要批量操作的链接';
              return;
            }
            this.isShow = true;
            this.linkMsg = {
              shopId: this.selectStore,
              checkboxModelLst: checkboxModelLst
            };
            this.linkMsg.checkboxModelLst = checkboxModelLst;
              if (type === 'batchSllSetInventoryObject') {
                this.dialogTitle = '批量设置链接库存对接';
              } else if (type === 'batchSynchronousInventory') {
                this.dialogTitle = '批量同步库存';
              } else {
                this.dialogTitle = '批量关闭链接库存对接';
              }
            break;
        }
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        // console.log(222, e);
        this.isShow = e.isShow;
        if (e.handleType) {
          this.isMsg = true;
          this.isSuc = true;
          this.txtMsg = '操作成功';
          this.loadAllShopLinkPageData();
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        this.loadAllShopLinkPageData();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        this.loadAllShopLinkPageData();
      },

      // tabs切换
      tabsChange(value) {
        this.$emit('tabschange', {type: value});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        // console.log(11199, e);
        // console.log(this.isSuc);
      }
    },
    created() {
      // 获取店铺下拉框信息
      this.getAllPXShopList();
      this.getAllBrandsList();
      this.getAllSizeGroupList();
      this.getAllClassList();
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .store_link_list {
    .store_link_list_top {
      .first_line {
        width: 100%;
        margin: 15px 0;

        & > div {
          display: inline-block;
          width: 12%;
          margin-right: 0.5%;

          &:nth-child(1) {
            margin-left: 1%;
          }
        }

        .inventory_list {
          width: 8%;
        }

        .inventory_msg {
          width: 9%;
        }
      }

      .second_line, .third_line {
        width: 100%;
        margin: 15px 0;

        & > div {
          display: inline-block;
          margin-right: 1%;

          &:nth-child(1) {
            margin-left: 1%;
          }
        }

        & > button {
          &:nth-child(1) {
            margin-left: 1%;
          }
        }
      }
    }

    .store_link_list_msg {
      height: calc(100% - 195px);

      .paging {
        width: 100%;
        max-width: 100%;
        text-align: right;
        margin: 20px 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/baby-management/store-link-list.vue